import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../../firebase-config";  // Import Firebase Authentication

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleLogout = async () => {
      try {
        await auth.signOut();
        navigate('/admin/login');  // Redirect to login page after logout
      } catch (error) {
        console.error("Logout error:", error);
      }
    };

    handleLogout();
  }, [navigate]);

  return <p>Logging out...</p>;
};

export default Logout;
